import { createSelector } from 'reselect';
import { ReduxState } from '../../common/types';

export const getUsers = (state: ReduxState) => state.users;
export const usersData = createSelector(getUsers, (users) => users.results);
export const areUsersLoaded = createSelector(usersData, (users) => !!users.length);

export const getUsersTotalItems = createSelector(getUsers, (users) => users.totalItems);
